import React from "react";
import styles from "./footer.module.css";
import sorsorsor from "../static/images/component_pic/sorsorsor.png";
import thaihealth from "../static/images/component_pic/logo-thaihealth.png";

function Footer() {
  return (
    <a
      href="https://creativehealthcampaign.thaihealth.or.th/microsite/healthyfamily/Inclusive/%E0%B8%AA%E0%B8%B9%E0%B8%87%E0%B8%A7%E0%B8%B1%E0%B8%A2%E0%B9%83%E0%B8%AB%E0%B9%89%E0%B8%9E%E0%B8%A3%E0%B9%89%E0%B8%AD%E0%B8%A1%E0%B8%81%E0%B9%88%E0%B8%AD%E0%B8%9940/content/4385"
      target="_blank"
      rel="noopener noreferrer"
      className={styles.footer}
    >
      <img className={styles.thaihealth} src={thaihealth} alt="40plus" />
      <img className={styles.sorsorsor} src={sorsorsor} alt="40plus" />
    </a>
  );
}

export default Footer;
